// Image upload that survives the production edge.
//
// Multipart POSTs to the live site come back as a Cloudflare 502 HTML page,
// which the browser reports as "The string did not match the expected pattern"
// (a JSON parse error). So images are downscaled in the browser and sent as
// base64 JSON, which goes through fine.

var API = process.env.REACT_APP_BACKEND_URL;
var MAX_EDGE = 1600;      // px on the longest side
var JPEG_QUALITY = 0.86;

function authHeaders() {
  var t = localStorage.getItem('admin_token');
  return t ? { Authorization: 'Bearer ' + t } : {};
}

function readAsDataUrl(file) {
  return new Promise(function(resolve, reject) {
    var fr = new FileReader();
    fr.onload = function() { resolve(fr.result); };
    fr.onerror = function() { reject(new Error('Could not read that file')); };
    fr.readAsDataURL(file);
  });
}

function hasTransparency(canvas, ctx) {
  try {
    var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    for (var i = 3; i < d.length; i += 4) {
      if (d[i] < 255) return true;
    }
    return false;
  } catch (e) {
    return true;  // tainted canvas — stay safe and keep PNG
  }
}

// Returns { dataUrl, filename }. Only genuinely transparent images stay PNG;
// opaque PNGs (screenshots) become JPEG, which is ~20x smaller.
export async function prepareImage(file) {
  var dataUrl = await readAsDataUrl(file);
  var img = await new Promise(function(resolve, reject) {
    var el = new Image();
    el.onload = function() { resolve(el); };
    el.onerror = function() { reject(new Error('That file is not a readable image')); };
    el.src = dataUrl;
  });

  var scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
  var canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(img.width * scale));
  canvas.height = Math.max(1, Math.round(img.height * scale));
  var ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  var keepPng = /^image\/png$/i.test(file.type) && hasTransparency(canvas, ctx);
  var type = keepPng ? 'image/png' : 'image/jpeg';
  var out = canvas.toDataURL(type, JPEG_QUALITY);
  var name = (file.name || 'image').replace(/\.[^.]+$/, '') + (keepPng ? '.png' : '.jpg');
  return { dataUrl: out, filename: name };
}

export async function uploadProductImage(slug, file, setPrimary) {
  var prepared = await prepareImage(file);
  var resp = await fetch(API + '/api/admin/product-images/' + encodeURIComponent(slug) + '/upload-base64', {
    method: 'POST',
    headers: Object.assign({ 'Content-Type': 'application/json' }, authHeaders()),
    body: JSON.stringify({
      filename: prepared.filename,
      data_base64: prepared.dataUrl,
      set_primary: !!setPrimary,
    }),
  });
  var data = await resp.json().catch(function() { return {}; });
  if (!resp.ok) {
    throw new Error(
      data.detail ||
      (resp.status === 413 ? 'Image too large for the server — try a smaller file'
        : resp.status === 502 || resp.status === 504
          ? 'The server dropped the request (HTTP ' + resp.status + ') — try again'
          : 'Upload failed (HTTP ' + resp.status + ')')
    );
  }
  return data;
}
